import { TextField, InputAdornment, IconButton } from '@material-ui/core';
import React, { useState } from 'react';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const InputField = props => {

    const { onChange,
        error,
        name,
        id,
        placeholder,
        type,
        value,
        label,
        disabled,
        required,
        style = {},
        containerStyle = {},
        onEnterPress = () => { } } = props;

    const [showPass, setShowPass] = useState(false);

    const onKeyPress = (event) => {
        event && event.key === 'Enter' && onEnterPress()
    }

    return (
        <div style={{ height: '90px', ...containerStyle }}>
            <TextField
                id={id}
                style={{ marginTop: '10px', marginBottom: '10px', ...style }}
                value={value}
                fullWidth={true}
                onChange={onChange}
                error={!!error}
                helperText={error}
                type={type === 'password' && showPass ? undefined : type}
                placeholder={placeholder}
                name={name}
                disabled={disabled}
                label={label}
                onKeyPress={onKeyPress}
                required={required}
                InputLabelProps={{
                    style: {
                        color: 'var(--placeholder-text)'
                    }
                }}
                InputProps={{
                    endAdornment: type === 'password' ? (
                        <InputAdornment position="end">
                            <IconButton onClick={() => setShowPass(!showPass)}>
                                {showPass ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </IconButton>
                        </InputAdornment>
                    ) : undefined,
                }}
            />
        </div>
    )
}

export default (InputField);